import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getConfirm = (state: RootState) => state.sceneConfiguration.confirm;

const getConfirmState = createSelector([getConfirm], (confirm) => confirm);

export default getConfirmState;
